export default {"src":"/_next/static/media/process-tracking-deleted.9b3cabc9.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};